<template lang="pug">
    .borderNav--item.borderNav--anatomy(v-audioHover="" @click="anatomyClick()")
        span.borderNav--item-text Anatomy
</template>
<script>
export default {
    methods: {
        anatomyClick() {
            this.$store.commit('mainNav', true)
            this.$store.commit('anatomy', false)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/anatomy.vue